import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogButtons, DialogContent, DialogTitle } from '@/Components/Dialog/Dialog';
import { DobButton } from '@dedalusdiit/dob-components';

function NotAllowedDialog(
    { isOpen, onOk }: Readonly<{ isOpen: boolean; onOk: React.MouseEventHandler<HTMLButtonElement> }>,
): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Dialog open={isOpen}>
            <DialogTitle>{t('NotAllowed')}</DialogTitle>
            <DialogContent>
                <div>{ t('NotAllowed') }</div>
            </DialogContent>
            <DialogButtons>
                <DobButton onClick={onOk}>{t('Ok')}</DobButton>
            </DialogButtons>
        </Dialog>
    );
}

export default NotAllowedDialog;
